import { render } from "./B2bProfileSignature.vue?vue&type=template&id=59a83df4&scoped=true&lang=pug"
import script from "./B2bProfileSignature.vue?vue&type=script&lang=js"
export * from "./B2bProfileSignature.vue?vue&type=script&lang=js"

import "./B2bProfileSignature.vue?vue&type=style&index=0&id=59a83df4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a83df4"]])

export default __exports__